import { PluginObject } from 'vue';
import Cookie, { CookieAttributes } from 'js-cookie';

const plugin: PluginObject<CookieAttributes> = {
  install(Vue) {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$cookie = Cookie;
  },
};

export default plugin;
